<div class="je">
  <ion-card>
    <ion-card-header>
      <ion-card-title>Jegy nélküli tantárgyak</ion-card-title>
      <ion-card-subtitle>
        Osztályonként és csoportonként: melyik tantárgyból kinek nincs még évközi jegye, ki tanítja (az órarend szerint,
        a megtartott óraszámmal) és mikor volt az utolsó jegy. A stornózott jegy nem számít; a tantárgy értékelése alól
        felmentett és az egyéni munkarendű tanuló, a vendégtanuló, valamint az egyéb foglalkozások (napközi, szakkör…)
        és az osztályfőnöki óra kimarad.
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div class="szurok">
        <ion-segment [(ngModel)]="idoszak" (ionChange)="toltes()">
          <ion-segment-button value="ev"><ion-label>Tanév eddig</ion-label></ion-segment-button>
          <ion-segment-button value="f1"><ion-label>I. félév</ion-label></ion-segment-button>
          <ion-segment-button value="f2"><ion-label>II. félév</ion-label></ion-segment-button>
          <ion-segment-button value="egyeni"><ion-label>Egyéni</ion-label></ion-segment-button>
        </ion-segment>
        <div class="sor">
          <ng-container *ngIf="idoszak === 'egyeni'">
            <ion-input type="date" label="Ettől" label-placement="stacked" [(ngModel)]="tol" (ionChange)="toltes()"></ion-input>
            <ion-input type="date" label="Eddig" label-placement="stacked" [(ngModel)]="ig" (ionChange)="toltes()"></ion-input>
          </ng-container>
          <ion-select label="Osztály" label-placement="stacked" interface="popover" [(ngModel)]="osztaly" (ionChange)="toltes()">
            <ion-select-option value="">Mind</ion-select-option>
            <ion-select-option *ngFor="let o of osztalyok" [value]="o.id">{{ o.nev }}</ion-select-option>
          </ion-select>
          <ion-input type="number" min="0" label="Legalább ennyi megtartott óra" label-placement="stacked" [(ngModel)]="minOra"></ion-input>
        </div>
        <div class="sor">
          <ion-toggle [(ngModel)]="csakSenkinek" labelPlacement="end">Csak ahol senkinek nincs jegye</ion-toggle>
          <ion-segment [(ngModel)]="nezet" class="nezet">
            <ion-segment-button value="tantargy"><ion-label>Tantárgyanként</ion-label></ion-segment-button>
            <ion-segment-button value="tanar"><ion-label>Tanáronként</ion-label></ion-segment-button>
          </ion-segment>
          <ion-button fill="outline" size="small" (click)="csv()" [disabled]="!sorok.length">
            <ion-icon slot="start" name="download-outline"></ion-icon>CSV
          </ion-button>
        </div>
      </div>

      <div *ngIf="betolt" class="ion-text-center ion-padding"><ion-spinner name="crescent"></ion-spinner></div>
      <p class="hiba" *ngIf="hiba">{{ hiba }}</p>

      <ng-container *ngIf="adat && !betolt && !hiba">
        <p class="halvany">
          {{ adat.tanev?.name }} · {{ adat.idoszak?.tol }} – {{ adat.idoszak?.ig }} ·
          <b>{{ sorok.length }}</b> tanítási egység, ebből <b>{{ senkinekDb() }}</b> ahol senkinek nincs jegye ·
          <b>{{ tanaronkent.length }}</b> tanár érintett
          <span *ngIf="adat.megjegyzes"> · {{ adat.megjegyzes }}</span>
        </p>
        <p class="halvany" *ngIf="!sorok.length">Nincs a szűrésnek megfelelő jegy nélküli tantárgy.</p>

        <!-- Tantárgyanként -->
        <table class="lista" *ngIf="nezet === 'tantargy' && sorok.length">
          <thead><tr><th>Osztály / csoport</th><th>Tantárgy</th><th>Tanár (megtartott óra)</th><th class="sz">Óra</th><th class="sz">Jegy nélkül</th><th>Utolsó jegy</th></tr></thead>
          <tbody>
            <ng-container *ngFor="let e of sorok">
              <tr (click)="valt(e)" class="kattinthato" [class.senki]="e.senkinek">
                <td>{{ e.egyseg }}</td><td>{{ e.tantargy }}</td><td>{{ tanarSzoveg(e) }}</td>
                <td class="sz">{{ e.orak }}</td>
                <td class="sz"><b>{{ e.jegy_nelkul }}</b>/{{ e.letszam }}</td>
                <td>{{ e.utolso_jegy || '—' }}</td>
              </tr>
              <tr *ngIf="nyitva[kulcs(e)]" class="reszlet">
                <td colspan="6">
                  <span *ngFor="let t of e.tanulok; let l = last">{{ t.nev }}<span class="halvany" *ngIf="t.osztaly && e.tipus === 'csoport'"> ({{ t.osztaly }})</span>{{ l ? '' : ', ' }}</span>
                  <span class="halvany" *ngIf="e.felmentett || e.egyeni_munkarend"> · kihagyva: {{ e.felmentett ? e.felmentett + ' felmentett' : '' }}{{ e.felmentett && e.egyeni_munkarend ? ', ' : '' }}{{ e.egyeni_munkarend ? e.egyeni_munkarend + ' egyéni munkarendű' : '' }}</span>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>

        <!-- Tanáronként -->
        <ng-container *ngIf="nezet === 'tanar'">
          <div class="tanar" *ngFor="let t of tanaronkent">
            <h3>{{ t.nev }} <span class="halvany">· {{ t.egysegek.length }} tantárgy/csoport, {{ t.jegyNelkul }} hiányzó jegy</span></h3>
            <table class="lista">
              <tbody>
                <tr *ngFor="let e of t.egysegek" [class.senki]="e.senkinek">
                  <td>{{ e.egyseg }}</td><td>{{ e.tantargy }}</td>
                  <td class="sz">{{ e.sajatOra }} óra</td>
                  <td class="sz"><b>{{ e.jegy_nelkul }}</b>/{{ e.letszam }} jegy nélkül</td>
                  <td>{{ e.utolso_jegy ? 'utolsó jegy: ' + e.utolso_jegy : 'még nincs jegy' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>
      </ng-container>
    </ion-card-content>
  </ion-card>
</div>
